import * as Sentry from "@sentry/react";

export const SUPPORT_EMAIL_ADDRESS = "support@veronics.org";

type SupportContext = {
  backendRequestId?: string;
  body?: string;
  eventId?: string | null;
  subject?: string;
};

const buildSupportEmailBody = ({ backendRequestId, body, eventId }: SupportContext) => {
  const details = [
    body || "Please describe what you were trying to do and what happened.",
    "",
    "Helpful details:",
    `Page: ${window.location.href}`,
    backendRequestId ? `Backend request ID: ${backendRequestId}` : null,
    eventId ? `Sentry event: ${eventId}` : null,
  ].filter(Boolean);

  return details.join("\n");
};

export const getSupportEmailHref = (context: SupportContext = {}) => {
  const subject = context.subject || "Veronics support request";
  const body = buildSupportEmailBody(context);

  return `mailto:${SUPPORT_EMAIL_ADDRESS}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const openSupportEmail = (context: SupportContext = {}) => {
  window.location.href = getSupportEmailHref(context);
};

export const openBugReport = async (context: SupportContext = {}) => {
  const feedback = Sentry.getFeedback();

  if (!feedback) {
    openSupportEmail({
      ...context,
      subject: context.subject || "Veronics bug report",
    });

    return;
  }

  const form = await feedback.createForm({
    tags: context.backendRequestId
      ? {
          backend_request_id: context.backendRequestId,
        }
      : undefined,
  });
  form.appendToDom();
  form.open();
};
